import {
  PlayArrow as PlayArrowIcon,
  Stop as StopIcon,
} from '@mui/icons-material';
import { Box, Grid, styled, Typography } from '@mui/material';

export const AccordionTitleWrapper = styled(Box)`
  display: flex;
  align-items: center;
  width: 100%;
  margin-left: -10px;
`;

export const AccordionTitle = styled(Typography)`
  flex: 1;
  font-weight: 500;
`;

export const StartIcon = styled(Typography)(
  ({ theme }) => `
  display: flex;
  width: 24px;
  height: 24px;
  background: ${theme.palette.primary.main};
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  color: white;
  font-size: 0.8rem;
  margin-right: 8px;
`,
);

const TriggerButton = () => `
    border-radius: 50%;
    padding: 3px;
    width: 24px;
    height: 24px;
    cursor: pointer;
  `;

export const StopIconStyled = styled(StopIcon)(
  ({ theme }) => `
      ${TriggerButton()}
      color: ${theme.palette.primary.dark};
      border: 1px solid ${theme.palette.primary.dark};
      background-color: ${theme.palette.primary.lighter};
    `,
);

export const PlayArrowIconStyled = styled(PlayArrowIcon)(
  ({ theme }) => `
      ${TriggerButton()}
      color: ${theme.palette.primary.dark};
      border: 1px solid ${theme.palette.primary.dark};
      background-color: ${theme.palette.primary.lighter};
      padding: 2px;
    `,
);

export const StyledLinkTypography = styled(Typography)(
  ({ theme, $active }) => `
  ${$active && `background-color: ${theme.palette.brand.lightBlue}`};
  &:hover {
    background-color: ${theme.palette.brand.lightGrey};
    }
  text-indent: 4px;
`,
);
export const StyledContainer = styled(Grid)`
  justify-content: center;
  padding: 2;
  margin-bottom: 2rem;
`;
